var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-selector',{attrs:{"available":_vm.available,"selected":_vm.selected,"disabled":_vm.disabled,"available-title":"Sensores disponíveis","selected-title":"Sensores selecionados"},on:{"select":_vm.select,"deselect":_vm.deselect}})}
var staticRenderFns = []

export { render, staticRenderFns }